module.exports = __webpack_public_path__ + "static/media/FaceBookAuth.e4dc9b5e.svg";